import { render } from "./MealReservationForm.vue?vue&type=template&id=6edeb2e8&scoped=true"
import script from "./MealReservationForm.vue?vue&type=script&lang=js"
export * from "./MealReservationForm.vue?vue&type=script&lang=js"

import "./MealReservationForm.vue?vue&type=style&index=0&id=6edeb2e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edeb2e8"]])

export default __exports__